import { Form } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AdditionalInfoForm from 'modules/Onboarding/Register/AdditionalDetails/AdditionalInfoForm'
import {
  Hobbies,
  Languages,
  SocialMedia,
} from 'modules/Onboarding/Register/AdditionalDetails/AdditionInfoInput'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'

const AdditionalDetails = ({
  setCurrent,
  studentData,
  studentFormData,
  updateStudentData,
  activeKey,
  getCities,
}) => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const formRef = React.createRef()
  const navigate = new useNavigate()
  const [casteValue, setCasteValue] = useState('')
  const [religionValue, setReligionValue] = useState('')
  const [locations, setLocations] = useState([])
  const [objective, setObjective] = useState(studentFormData?.resume?.objective)
  const [extraCurriculars, setExtraCurriculars] = useState(
    studentFormData?.studentPersonalProfile?.extraCurriculars
  )
  const [submitLoading, setSubmitLoading] = useState(false)

  const [hobbies, setHobbies] = useState([
    {
      component: Hobbies,
      type: 'hobbie_0',
    },
  ])
  const [languages, setLanguages] = useState([
    {
      component: Languages,
      type: 'language_0',
    },
  ])
  const [socials, setSocials] = useState([])
  const [hobbieList, setHobbieList] = useState([])
  const [languageList, setLanguageList] = useState([])
  const [socilaMedia, setSocilaMedia] = useState([])
  const [socialMediaList, setSocialMediaList] = useState([])
  const [socialURLList, setSocialURLList] = useState([])
  const [allLocations, setAllLocations] = useState([])
  const [isDisableformValidation, setIsDisableformValidation] = useState(true)
  const [isPhysicallyChallenged, setIsPhysicallyChallenged] = useState(
    studentFormData?.studentPersonalProfile?.isPhysicallyChallenged
  )

  const [isAnyWhere, setIsAnyWhere] = useState(
    studentFormData?.studentPersonalProfile?.isAnywhere
  )

  const hobbiesHandler = (isAdd, isDelete, deleteVlaue) => {
    let arr = []
    arr.push({
      component: Hobbies,
      type: 'hobbie_' + hobbies?.length,
    })
    if (isAdd) {
      setHobbies(hobbies.concat(arr))
    }
    if (isDelete) {
      let hobbieList = hobbies?.filter(data => data?.type !== deleteVlaue)
      setHobbies(hobbieList)
      form.setFieldsValue({
        [deleteVlaue]: '',
      })
    }
    getHobbbieList()
  }

  const languagesHandler = (isAdd, isDelete, deleteVlaue) => {
    let arr = []
    arr.push({
      component: Languages,
      type: 'language_' + languages?.length,
    })
    if (isAdd) {
      setLanguages(lang => lang.concat(arr))
    }

    if (isDelete) {
      let languageList = languages?.filter(data => data?.type !== deleteVlaue)
      setLanguages(languageList)
      form.setFieldsValue({
        [deleteVlaue]: '',
      })
    }
  }

  const socialsHandler = (isAdd, isDelete, deleteVlaue) => {
    let arr = []
    arr.push({
      component: SocialMedia,
      type: 'socialmedia_' + socials?.length + 1,
    })
    if (isAdd) {
      setSocials(so => so.concat(arr))
    }
    if (isDelete) {
      let socialList = socials?.filter(data => data?.type !== deleteVlaue)
      setSocials(socialList)
      form.setFieldsValue({
        [deleteVlaue]: '',
      })
    }
  }
  let getPerfCityData = async search => {
    let list = await getCities(search)

    const newOptions = [
      ...list.cities.map(city => ({
        value: city.city_id,
        label: city.city_name,
        type: 'city',
        payload: city,
      })),
      ...list.states.map(state => ({
        value: state.state_id,
        label: state.state_name,
        type: 'state',
        payload: state,
      })),
    ]

    setAllLocations(newOptions)
  }

  useEffect(() => {
    form.setFieldsValue({
      caste: studentFormData?.studentPersonalProfile?.caste,
      religion: studentFormData?.studentPersonalProfile?.religion,
      preferredJobLocation:
        studentFormData?.studentPersonalProfile?.preferredJobLocation,
      objective: studentFormData?.resume?.objective,
      isPhysicallyChallenged:
        studentFormData?.studentPersonalProfile?.isPhysicallyChallenged,
      isAnywhere: studentFormData?.studentPersonalProfile?.isAnywhere,
      physicalChallenge:
        studentFormData?.studentPersonalProfile?.physicalChallenge,
      extraCurriculars:
        studentFormData?.studentPersonalProfile?.extraCurriculars,
    })
    getPerfCityData('')
    setIsAnyWhere(studentFormData?.studentPersonalProfile?.isAnywhere)
    setCasteValue(studentFormData?.studentPersonalProfile?.caste)
    setReligionValue(studentFormData?.studentPersonalProfile?.religion)

    let hobbiesList = []
    studentFormData?.studentPersonalProfile?.hobbies?.map((data, index) => {
      let type = 'hobbie_' + index
      form.setFieldsValue({
        [type]: data,
      })
      hobbiesList.push({
        component: Hobbies,
        type: type,
      })
    })
    setHobbies(
      studentFormData?.studentPersonalProfile?.hobbies?.length > 0
        ? hobbiesList
        : hobbies
    )

    let languageList = []
    studentFormData?.studentPersonalProfile?.languages?.map((data, index) => {
      let type = 'language_' + index
      form.setFieldsValue({
        [type]: data,
      })
      languageList.push({
        component: Languages,
        type: type,
      })
    })
    setLanguages(
      studentFormData?.studentPersonalProfile?.languages?.length > 0
        ? languageList
        : languages
    )
    const locationPreffered =
      studentFormData?.studentPersonalProfile?.preferredJobLocation || []

    const mappedCities = locationPreffered
      .filter(city => city?.city_id || city?.state_id)
      .map(city => ({
        value: city?.city_id ? city?.city_id : city?.state_id,
        label: city?.city_name ? city?.city_name : city?.state_name,
        payload: city,
      }))
    setLocations(mappedCities)

    let socialList = []
    studentFormData?.studentPersonalProfile?.socialMedia?.map((data, index) => {
      let type = 'socialmedia_' + index
      form.setFieldsValue({
        [type]: {
          media: data?.media,
          link: data?.link,
        },
      })
      socialList.push({
        component: SocialMedia,
        type: type,
      })
    })
    setSocials(
      studentFormData?.studentPersonalProfile?.socialMedia?.length > 0
        ? socialList
        : socials
    )
    setObjective(studentFormData?.resume?.objective)
    setExtraCurriculars(
      studentFormData?.studentPersonalProfile?.extraCurriculars
    )
  }, [studentFormData])

  useEffect(() => {
    getHobbbieList()
    getLanguageList()
  }, [languages, hobbies])

  useEffect(() => {
    getSocailMediaList()
  }, [socials])
  const getKeyValuePair = value => {
    let formObject = form.getFieldsValue()

    const data = Object.keys(formObject)
      .filter(key => key.includes(value))
      .reduce((cur, key) => {
        if (value == 'socialmedia') {
          if (typeof formObject[key].link == 'function') {
            formObject[key].link = undefined
            form.setFieldValue(key, {
              media: formObject[key]?.media,
              link: formObject[key]?.link,
            })
          }
        }
        return Object.assign(cur, { [key]: formObject[key] })
      }, {})
    return data
  }

  const getHobbbieList = () => {
    let hobbie = getKeyValuePair('hobbie')
    setHobbieList(Object.entries(hobbie))
  }
  const getLanguageList = () => {
    let language = getKeyValuePair('language')
    setLanguageList(Object.entries(language))
  }

  const getSocailMediaList = () => {
    let socialmedia = getKeyValuePair('socialmedia')
    setSocilaMedia(Object.values(socialmedia))
    let medialList = []
    let linkList = []
    Object.entries(socialmedia).forEach(([key, value]) => {
      medialList.push([key, value?.media])
      linkList.push([key, value?.link])
    })
    setSocialMediaList(medialList)
    setSocialURLList(linkList)
  }

  const submitHandler = async values => {
    let hobbies = []
    let languages = []

    hobbieList.forEach(([key, values]) => {
      hobbies.push(values)
    })
    languageList.forEach(([key, values]) => {
      languages.push(values)
    })

    setSubmitLoading(true)

    let payload = {
      admin: {
        ...studentFormData?.admin,
        countryCode: studentFormData?.admin?.countryCode,
      },
      student: { ...studentFormData?.student, currentState: 3 },
      studentPersonalProfile: {
        ...studentFormData?.studentPersonalProfile,
        caste: values?.caste || '',
        religion: values?.religion || '',
        isPhysicallyChallenged: isPhysicallyChallenged,
        physicalChallenge: values?.physicalChallenge,
        preferredJobLocation:
          values?.preferredJobLocation
            ?.filter(item => item && item.payload)
            .map(item => item.payload) || [],

        isAnywhere: values?.isAnyWhere,
        languages: languages || [],
        hobbies: hobbies,
        socialMedia: socilaMedia || [],
        extraCurriculars: values?.extraCurriculars,
      },
      currentCourse: !studentFormData?.student?.isExpCandidate
        ? studentFormData?.currentCourse
        : {},
      education: studentFormData?.education,
      resume: {
        ...studentFormData?.resume,
        objective: values?.objective,
      },
      degreeStreamMap: !studentFormData?.student?.isExpCandidate
        ? {
          degreeId: studentFormData?.currentCourse?.degreeId,
          streamId: studentFormData?.currentCourse?.streamId,
        }
        : {},
      checkForApproval: true,
      checkDeleteSection: ["studentPersonalProfile"],
    }
    if (payload?.currentCourse?.specialisationId === null) {
      delete payload?.currentCourse?.specialisationId
    }
    if (payload?.currentCourse?.degreeStreamMapId === null) {
      delete payload?.currentCourse?.degreeStreamMapId
    }
    if (payload?.studentPersonalProfile?.secondaryEmail === null) {
      delete payload?.studentPersonalProfile?.secondaryEmail
    }

    studentFormData?.education.map((item, index) => {
      if (item?.skills === null) delete payload?.education[index]?.skills
      if (item?.degreeStreamMapId === null)
        delete payload?.education[index]?.degreeStreamMapId
    })
    let response = await updateStudentData(studentData?.id, payload)
    if (response === true) {
      SuccessMessage('Additional details saved successfully!')
      setSubmitLoading(false)

      navigate(`/onboarding/notification/${studentData?.id}`)
    } else {
      setSubmitLoading(false)

      ErrorMessage(response?.response?.data?.message)
    }
  }

  const onChangeCareerObject = value => {
    setObjective(value)
  }

  const onChangeExtraCurriculars = value => {
    setExtraCurriculars(value)
  }

  return (
    <Form
      scrollToFirstError
      onFinish={submitHandler}
      id={'additionalInfoForm'}
      form={form}
      ref={formRef}
      layout="vertical"
    >
      <AdditionalInfoForm
        form={form}
        formRef={formRef}
        hobbies={hobbies}
        languages={languages}
        locations={locations}
        setLocations={setLocations}
        socials={socials}
        hobbiesHandler={hobbiesHandler}
        languagesHandler={languagesHandler}
        socialsHandler={socialsHandler}
        casteValue={casteValue}
        setCasteValue={setCasteValue}
        religionValue={religionValue}
        setReligionValue={setReligionValue}
        objective={objective}
        setObjective={setObjective}
        extraCurriculars={extraCurriculars}
        setExtraCurriculars={setExtraCurriculars}
        hobbieList={hobbieList}
        languageList={languageList}
        socialMediaList={socialMediaList}
        socialURLList={socialURLList}
        getHobbbieList={getHobbbieList}
        getLanguageList={getLanguageList}
        getSocailMediaList={getSocailMediaList}
        isDisableformValidation={isDisableformValidation}
        setIsDisableformValidation={setIsDisableformValidation}
        isPhysicallyChallenged={isPhysicallyChallenged}
        isAnyWhere={isAnyWhere}
        setIsAnyWhere={setIsAnyWhere}
        setIsPhysicallyChallenged={setIsPhysicallyChallenged}
        studentFormData={studentFormData}
        getPerfCityData={getPerfCityData}
        allLocations={allLocations}
      />
      <Control width="100%" flexEnd gap="15px" top="35px">
        <Button.Secondary
          text="Back"
          onClick={() => setCurrent(activeKey - 1)}
        />
        <Button.Primary
          text="Save & Continue"
          htmlType={'submit'}
          form={'additionalInfoForm'}
          onClick={() => setIsDisableformValidation(false)}
          disable={submitLoading}
        />
      </Control>
    </Form>
  )
}

export default AdditionalDetails
